import { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/common/ErrorBoundary';
import userContext from './configs/context/context';
import { AuthProvider } from './hooks/AuthProvider';
import Layout from './components/common/Layout';
import HomePage from './components/common/HomePage';
import Orders from './components/page/orders/Orders';
import Product from './components/page/products/Product';
import Enquiry from './components/page/enquiry/Enquiry';
import Wholesale from './components/page/wholesale/Wholesale';
import CustomerPage from './components/page/customers/CustomerPage';
import Categories from './components/page/category/Categories';
import LoginPage from './components/forms/Login';
import ProtectedRoute from './components/common/ProtectedRoute';
import ProductEnquiry from './components/page/ProductEnquiry/ProductEnquiry';
import 'react-toastify/dist/ReactToastify.css';
import CurrencyConvert from './components/page/currencyConvert/CurrencyConvert';
import CreateProductPage from './components/page/products/CreateProductPage';
import EditProductPage from './components/page/products/EditProductPage';
import CouponView from './components/page/Coupon/couponView/couponView';
import VendorRegistrationForm from './components/page/Vendor/vendorForm/Vendor-form';
import VendorRequestsTable from './components/page/Vendor/VendorRequest/VendorRequest';
import VendorRequestView from './components/page/Vendor/VendorRequestView/VendorRequestView';
import VendorApproveTable from './components/page/Vendor/VendorApproved/VendorApproved';
import VendorApprovedView from './components/page/Vendor/VendorApproved/VendorView';
import VendorEditFrom from './components/page/Vendor/vendorForm/EditFrom/VendorEditFrom';
import VendorLogin from './components/page/Vendor/Login/VendorLogin';
import Profilevendor from './components/page/Vendor/Profile/Profile-vendor';
import CategoriesVendor from './components/page/Vendor/Vendor-main-pages/Categories/Categories';
import ProductsVendor from './components/page/Vendor/Vendor-main-pages/Products/Products';
import CreateProductVendor from './components/page/Vendor/Vendor-main-pages/Products/CreateProductVendor';
import OrdersVendor from './components/page/Vendor/Vendor-main-pages/Orders/Orders';
import Users from './components/page/users/Users';
import VendorProductTable from './components/page/Vendor/VendorProduct/VendorProduct';
import VendorProductSingleview from './components/page/Vendor/VendorProduct/vendorproductSingleView/VendorSingleview';
import DashboardVendor from './components/page/Vendor/Vendor-main-pages/Dashboard/Dashboard';
import WholesaleVendor from './components/page/Vendor/Vendor-main-pages/Whole sale/Wholesale';
import ProductEnquiriesVendor from './components/page/Vendor/Vendor-main-pages/Product Enquiries/ProductEnquiries';

function App() {
	const [cart, setCart] = useState([]);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [Vendorme, setVendorme] = useState([]);
	const defaultValue = {
		cart,
		setCart,
		isAuthenticated,
		setIsAuthenticated,
		setVendorme,
		Vendorme,
	};

	useEffect(() => {
		const accessToken = localStorage.getItem('token');
		if (accessToken) {
			setIsAuthenticated(true);
		} else {
			setIsAuthenticated(false);
		}
	}, []);

	return (
		<ErrorBoundary>
			<userContext.Provider value={defaultValue}>
				<AuthProvider>
					<BrowserRouter>
						<Routes>
							<Route path="/login" element={<LoginPage />} />
							<Route path="/:slug/login" element={<VendorLogin />} />
							<Route element={<ProtectedRoute />}>
								<Route path="/" element={<Layout />}>
									<Route path="/" element={<HomePage />} />
									<Route path="/category" element={<Categories />} />
									<Route path="/product" element={<Product />} />
									<Route path="/create-product" element={<CreateProductPage />} />
									<Route
										path="/product/:product_id"
										element={<EditProductPage />}
									/>
									<Route path="/order" element={<Orders />} />
									<Route path="/users" element={<Users />} />
									<Route path="/:slug/order" element={<OrdersVendor />} />
									<Route path="/enquiries" element={<Enquiry />} />
									<Route path="/wholesale" element={<Wholesale />} />
									<Route path="/customer" element={<CustomerPage />} />
									<Route path="/product-enquiry" element={<ProductEnquiry />} />
									<Route path="/:slug/category" element={<CategoriesVendor />} />
									<Route path="/:slug/product" element={<ProductsVendor />} />
									<Route path="/:slug/dashboard" element={<DashboardVendor />} />

									<Route
										path="/:slug/create-product"
										element={<CreateProductVendor />}
									/>
									<Route
										path="/:slug/product/:product_id"
										element={<EditProductPage />}
									/>
									<Route path="/:slug/wholesale" element={<WholesaleVendor />} />
									<Route
										path="/:slug/product-enquiry"
										element={<ProductEnquiriesVendor />}
									/>

									<Route
										path="/currency-converstion"
										element={<CurrencyConvert />}
									/>
									<Route path="/coupon" element={<CouponView />} />
									<Route
										path="/vendor/create"
										element={<VendorRegistrationForm />}
									/>
									<Route
										path="/vendor/request"
										element={<VendorRequestsTable />}
									/>
									<Route
										path="/vendor/approved"
										element={<VendorApproveTable />}
									/>
									<Route
										path="/vendor/request/:id"
										element={<VendorRequestView />}
									/>
									<Route
										path="/vendor/approved/:id"
										element={<VendorApprovedView />}
									/>
									<Route
										path="/vendor/product/view/:id"
										element={<VendorProductSingleview />}
									/>
									<Route
										path="/vendor/products"
										element={<VendorProductTable />}
									/>
									<Route path="/vendor/edit/:id" element={<VendorEditFrom />} />
									<Route path="/:slug/me" element={<Profilevendor />} />
								</Route>
							</Route>
						</Routes>
					</BrowserRouter>
				</AuthProvider>
			</userContext.Provider>
		</ErrorBoundary>
	);
}

export default App;
